import React, { useMemo } from 'react';

import { parseGraphBlogPostsToArray } from '@src/utils/parsers';

import SEO from '@commons/SEO';
import { Link } from '@commons/link/Link';
import { Header } from '@commons/header/Header';
import { StandardSection } from '@commons/standard-section/StandardSection';
import { HTMLRender } from '@commons/html-render/HTMLRender';
import { BlogPostCard } from '@commons/blog-post-card/BlogPostCard';
import featuredImage from '@images/header-images/featured_image_glossary.jpg';

import * as styles from './glossary-content.module.scss';

export const GlossaryContent = ({ html, glossaryTitle, seoTitle, seoDescription, readMorePosts }) => {
  const blogPostsData = useMemo(() => {
    return parseGraphBlogPostsToArray(readMorePosts);
  }, []);

  const ReadAlso = () => blogPostsData.map((el) => <BlogPostCard key={el.path} {...el} />);

  const firstLetterOfTitle = glossaryTitle.slice(0, 1);
  const arrayBreadcrumbNav = ['Glossary', firstLetterOfTitle, glossaryTitle];

  return (
    <>
      {seoTitle && (
        <SEO
          title={glossaryTitle}
          seoTitle={seoTitle || glossaryTitle}
          description={seoDescription}
          featuredImage={featuredImage}
        />
      )}
      <Header
        title={glossaryTitle}
        descriptionTitle="CodiLime Glossary"
        descriptionText="Some common networking terms clearly explained"
        id="glossary_header"
        src="header-images/glossary_bg.jpg"
        className={styles.header}
        descriptionTitleH3
        headerTitleH1
      />
      <StandardSection
        id="glossary"
        classNames={{ outerWrapper: styles.outerWrapper, innerWrapper: styles.innerWrapper }}
      >
        <div className={styles.glossaryContainer}>
          <div className={styles.descriptionContainer}>
            <div className={styles.breadcrumbs}>
              {arrayBreadcrumbNav.map((text, index) => {
                return index === 2 ? (
                  <p key={index + text}>{text}</p>
                ) : (
                  <Link key={index} href="/glossary/">
                    {text} /
                  </Link>
                );
              })}
            </div>
            <article>
              <HTMLRender content={html} />
            </article>
            {blogPostsData && (
              <>
                <h3 className={styles.readMoreSection}>Read more:</h3>
                <div className={styles.postsContainer}>
                  <ReadAlso />
                </div>
              </>
            )}
          </div>
        </div>
      </StandardSection>
    </>
  );
};
